import React from "react";
import useStyles from './styles';


const FooterPage = () => {
    const classes = useStyles();
  return (
    <div className={classes.footer} style={{textAlign:"center"}}>
    <p style={{color:'white'}}>&copy; {new Date().getFullYear()} Copyright: <a style={{color:"white"}}href="https://www.cibera.co"> Cibera </a></p>
    </div>

    // <MDBFooter color="blue" className="font-small pt-4 mt-4">
    //   <MDBContainer fluid className="text-center text-md-left">
    //     <MDBRow>
    //       <MDBCol md="6">
    //         <h5 className="title">Cibera Demo</h5>
    //       </MDBCol>
    //       <MDBCol md="6">
    //       </MDBCol>
    //     </MDBRow>
    //   </MDBContainer>
    //   <div className="footer-copyright text-center py-3">
    //     <MDBContainer fluid>
    //       &copy; {new Date().getFullYear()} Copyright: <a href="https://www.cibera.co"> Cibera </a>
    //     </MDBContainer>
    //   </div>
    // </MDBFooter>
  );
}

export default FooterPage;